import { ConfigProvider } from 'antd';
import ptBR from 'antd/locale/pt_BR';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import type { JSX } from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import AppRoutes from '~/routes/AppRoutes';
import PullToRefresh from './components/atoms/_shared/PullToRefresh';
import Alert from './components/molecules/_shared/Alert';
import ErrorBoundary from './components/organisms/_shared/ErrorBoundary';
import i18n from './configs/i18n';
import AppHeartbeat from './routes/AppHeartbeat';
import useGlobalStore from './stores/global/useGlobalStore';
import { defaultTheme } from './styles/theme';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/syne/400.css';
import '@fontsource/syne/500.css';
import '@fontsource/syne/600.css';
import '@fontsource/syne/700.css';

import GlobalStyle from './styles/GlobalStyle.styled';

import '@ant-design/v5-patch-for-react-19';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');
dayjs.extend(weekOfYear);
dayjs.extend(relativeTime);

export default function App(): JSX.Element {
  const { alert, isAlertActive } = useGlobalStore();

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppHeartbeat />
        <I18nextProvider i18n={i18n}>
          <ConfigProvider locale={ptBR} theme={defaultTheme}>
            <PullToRefresh />
            <AppRoutes />
            <GlobalStyle />
            <Alert
              message={alert.message}
              type={alert.type}
              timeout={alert.timeout}
              show={isAlertActive}
            />
          </ConfigProvider>
        </I18nextProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
